import {Component, OnInit} from '@angular/core';
import {UserManager} from 'oidc-client';
import {filter} from 'rxjs/operators';
import {ApiService} from 'src/app/services/api.service';
import {AuthService} from 'src/app/services/auth.service';
import {environment} from 'src/environments/environment';
import {Event, RouterEvent, Router, NavigationEnd} from '@angular/router';
import {MessageService} from 'primeng/api';
import {NgxSpinnerService} from 'ngx-spinner';
import {isEqual, first, compact, intersection} from 'lodash';
const queryString = require('query-string');
declare var $: any;

@Component({
  // moduleId: module.id,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})

export class SidebarComponent implements OnInit {
  menuItems: any[] = [];
  listmenuChecks = [];
  isWarning = 0;
  isShowheader = true;
  pathname: string;
  isHorizontal: boolean = true;
  isSidebarExpanded: boolean = true;
  expandedMenu: string = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    private apiService: ApiService,
    private messageService: MessageService,
    private spinner: NgxSpinnerService,
  ) {
    if (localStorage.hasOwnProperty('setting_menu') && localStorage.getItem('setting_menu') != null) {
      const setting_menu: string = localStorage.getItem('setting_menu');
      console.log(setting_menu);
      this.isHorizontal = setting_menu === 'horizontal' ? true : false;
    } else {
      this.isHorizontal = true;
    }
    const pathname = window.location.pathname;
    this.pathname = pathname;
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((e: any) => {
      if (this.router.url && this.router.url.includes('chat-ui')) {
        this.isShowheader = false;
      } else {
        this.isShowheader = true;
      }
      if (this.menuItems.length > 0) {
        this.parseObjectProperties(this.menuItems, e.url);
        this.menuItems = [...this.menuItems];
        localStorage.setItem('menuItems', JSON.stringify(this.menuItems));
      } else {
        this.getListMenuByUserId(pathname);
      }
    });
  }


  getWebId() {
    const pathname = window.location.pathname;
    if (pathname) {
      let webId = '';
      const category = pathname.split('/');
      if (category.length > 0 && category.indexOf('nhan-su') > -1) {
        webId = '6f1b0fa4-02dd-4afc-8113-c2a4cfdc0342';
      } else if (category.length > 0 && category.indexOf('chinh-sach') > -1) {
        webId = '08e95a53-7344-489a-b84e-0d81c8a7ee86';
      } else if (category.length > 0 && category.indexOf('luong-thue') > -1) {
        webId = 'c7ce1a4e-e7e7-4308-9a42-0f6c41476536';
      } else if (category.length > 0 && category.indexOf('tuyen-dung') > -1) {
        webId = 'a5c0d813-e36f-448d-a323-42def75c43da';
      } else {
        webId = '7af9293e-0a78-4b53-ae0e-288abbf7e844';
      }
      return webId;
    } else {
      return '';
    }
  }

  getListMenuByUserId(pathname) {
    const queryMeny = queryString.stringify({
      userId: this.authService.getClaims().sub
      , webId: this.getWebId()
    });
    this.apiService.getWebMenuListByUserId(queryMeny).subscribe(results => {
      this.menuItems = results.data.webMenus.filter(menuItem => menuItem);
      this.parseObjectProperties(this.menuItems, pathname);
      localStorage.setItem('menuItems', JSON.stringify(results.data.webMenus));
      this.menuItems = [...this.menuItems];
    });
  }


  async ngOnInit() {
    const savedState = localStorage.getItem('sidebar_expanded');
    this.isSidebarExpanded = savedState !== null ? savedState === 'true' : true;
  }

  toggleSidebar() {
    this.isSidebarExpanded = !this.isSidebarExpanded;
    localStorage.setItem('sidebar_expanded', String(this.isSidebarExpanded));
  }

  toggleMenu(item: any) {
    if (!this.isSidebarExpanded) {
      this.isSidebarExpanded = true;
      localStorage.setItem('sidebar_expanded', 'true');
    }
    item.expanded = !item.expanded;
  }

  trackByMenu(index: number, item: any): any {
    return item.menuId || item.id || index;
  }

  convetArry(datas) {
    for (const item of datas) {
      this.listmenuChecks.push(item);
      if (item.submenus && item.submenus.length > 0) {
        this.convetArry(item.submenus);
      }
    }
  }

  parseObjectProperties(obj: any[], pathname: string) {
    if (obj) {
      for (const k of obj) {
        if (k) {
          if (k.path && k.classs !== 'navigation-header') {
            k.icon = '';
          }
          if (k.classs === 'nav-item' && k.path === '') {
            const router = this.router.url ? this.router.url.split('/') : [];
            if (router.indexOf(k.menuId) > -1) {
              localStorage.setItem('menuActive', JSON.stringify(k));
              this.router.navigate(['/notfound', k.menuId]);
            }
          }
          k.command = () => {
            if (k.classs === 'nav-item' && k.path === '') {
              localStorage.setItem('menuActive', JSON.stringify(k));
              this.router.navigate(['/notfound', k.menuId]);
            }
          };
          if (k.path && k.classs === 'nav-link') {
            k.routerLink = k.path;
          }
          if (k.children && k.children.length > 0) {
            k.items = k.children.filter((d: any) => d.classs && (d.classs.indexOf('hidden') < 0));
          }
          if (k.routerLink) {
            // active menu con
            if (k.classs === 'navigation-header') {
              if (k.routerLink && pathname.includes(k.routerLink)) {
                k.styleClass = 'parent_active' + ' ' + k.classs;
                k.expanded = true;
              } else {
                k.styleClass = 'parent_no_active' + ' ' + k.classs;
                k.expanded = false;
              }
            } else {
              const newpathname = pathname ? compact(pathname.split('/')) : [];
              const newrouterLink = k.routerLink ? compact(k.routerLink.split('/')) : [];
              if (newpathname.length <= newrouterLink.length) {
                if (k.routerLink && pathname === k.routerLink) {
                  k.styleClass = k.classs + ' active' + ' ' + k.classs;
                  k.icon = '';
                } else {
                  k.styleClass = k.classs + ' no-active' + ' ' + k.classs;
                  k.icon = '';
                }
              } else {
                if (k.routerLink && isEqual(intersection(newpathname, newrouterLink), newrouterLink)) {
                  k.styleClass = k.classs + ' active' + ' ' + k.classs;
                  k.icon = '';
                } else {
                  k.styleClass = k.classs + ' no-active' + ' ' + k.classs;
                  k.icon = '';
                }
              }
            }
          } else {
            // active cha
            // if (k.path && pathname && pathname.split('/').indexOf(k.path) > -1 && k.classs === 'navigation-header') {
            //   k.styleClass = 'parent_active' + ' ' + k.classs;
            // } else {
            //   k.styleClass = 'parent_no_active' + ' ' + k.classs;
            // }

            if (k.children && k.children.length > 0) {
              const items = k.children.filter((i: any) => i.path && pathname.includes(i.path));
              if (items.length > 0) {
                k.styleClass = 'parent_active' + ' ' + k.classs;
                k.expanded = true;
              } else {
                k.styleClass = 'parent_no_active' + ' ' + k.classs;
                k.expanded = false;
              }
            } else {
              if (k.path === '/home') {
                k.routerLink = k.path;
                k.icon = 'uni-icon uni-home-building uni-white-color uni-hover-orange';
                // k.isExternalLink = true;
              }
            }
          }

          if (k.hasOwnProperty('items') && Array.isArray(k.items) && k.items.length > 0) {
            this.parseObjectProperties(k.items, pathname);
          }
        }
      }
    }
  }

  findNodeInTree2(list, nodeId, element1): any {
    for (let i = 0; i < list.length; i++) {
      if (list[i].path === nodeId) {
        element1.columnValue = list[i].badgeClass;
        break;
      } else if (Array.isArray(list[i].submenus) && list[i].submenus.length) {
        this.findNodeInTree2(list[i].submenus, nodeId, element1);
      }
    }
  }

  private manager: UserManager = new UserManager(environment.authenSettings);

  navigateTo(route: string) {
    if (route) {
      this.router.navigate([route]);
    }
  }
}
